import { createSlice } from "@reduxjs/toolkit";

interface TimeState {
  now: number;
}

const initialState: TimeState = {
  now: Date.now(),
};

const timeSlice = createSlice({
  name: "time",
  initialState,
  reducers: {
    setNow: (state) => {
      state.now = Date.now();
    },
  },
});

export const { setNow } = timeSlice.actions;
export default timeSlice.reducer;
